import Config from 'react-native-config';
import { ProviderDetail } from 'store/findProvider/types';
import { Consumer, Insurance } from 'store/profile/types';

/**
 * This code is very explicit on purpose to make it more understandable
 * Determines whether a given provider, for a given consumer, with a given set of insurances
 * is eligible to be set as a users pcp provider
 */
export const getCanSetProviderAsPcp = (
  provider: ProviderDetail,
  consumer: Consumer,
  insurances: Insurance[]
) => {
  // Provider must be a selecthealth provider
  if (!provider.isSelectHealth) {
    return false;
  }

  // Consumer must be a select health subscriber
  if (!consumer.shSubscriberNumber) {
    return false;
  }

  // Must have an insurance with facets as the source (sh insurance)
  const facetsInsurance = insurances.find(insurance => insurance.source === 'Facets');
  if (!facetsInsurance) {
    return false;
  }

  // Must be a member of the selecthealth insurance
  const insuranceMember = facetsInsurance.members.find(
    member => member.consumerId === consumer.consumerId
  );

  if (!insuranceMember) {
    return false;
  }

  return true;
};

export function kyruusEnabled() {
  return Config.KYRUUS_SEARCH === 'enabled';
}
